import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Card, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, FormGroup, ButtonGroup, ButtonToolbar } from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../assets/scss/cadastro_rotas.scss';

import { fetchComAuth, fetchComAuthJson } from '../../common/api';
import { api } from "../../config";
import MapaRoteamento from './MapaRoteamento';
import GerenciadorDeRotas from './GerenciamentoMapaRota';

const CadastroRoteamentoMapa = ({ feiraId }) => {
  const [isEditMode, setIsEditMode] = useState(false);

  const [mapData, setMapData] = useState(null);
  const [fundoUrl, setFundoUrl] = useState('');
  const [estandesCadastrados, setEstandesCadastrados] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [ferramentaAtiva, setFerramentaAtiva] = useState('addNode');
  const [nodes, setNodes] = useState([]);
  const [edges, setEdges] = useState([]);
  const [edgeStartNode, setEdgeStartNode] = useState(null);

  const [tiposEspacoFeira, setTiposEspacoFeira] = useState([]);
  const [tipoEspacoSelecionado, setTipoEspacoSelecionado] = useState("");

  const [modalPontoVisivel, setModalPontoVisivel] = useState(false);
  const [modalDestinoVisivel, setModalDestinoVisivel] = useState(false);
  const [pontoTemporarioCoords, setPontoTemporarioCoords] = useState(null); // {x, y}
  const [descricaoNovoPonto, setDescricaoNovoPonto] = useState("");
  const [nomeNovoDestino, setNomeNovoDestino] = useState("");
  const [modoContinuo, setModoContinuo] = useState(false);
  const [ultimaConfig, setUltimaConfig] = useState({ nome: '', tipo: '' });
  const [mousePos, setMousePos] = useState(null); 

  const [hoveredNode, setHoveredNode] = useState(null); 
  const [hoverClientPos, setHoverClientPos] = useState(null); 

  const [selectedNodeIds, setSelectedNodeIds] = useState([]);
  const [dragState, setDragState] = useState(null);
  const [modalAutoLinkVisivel, setModalAutoLinkVisivel] = useState(false);
  const [autoLinkPropostas, setAutoLinkPropostas] = useState([]);
  const [autoLinkSelecionadas, setAutoLinkSelecionadas] = useState(() => new Set());
  const [autoLinkPreviewEdges, setAutoLinkPreviewEdges] = useState([]);
  const [coverageRects, setCoverageRects] = useState([]);
  const [modalRegrasFluxoVisivel, setModalRegrasFluxoVisivel] = useState(false);
  const [isSavingRegraFluxo, setIsSavingRegraFluxo] = useState(false);
  const [regrasFluxo, setRegrasFluxo] = useState([]);
  const [regraFluxoForm, setRegraFluxoForm] = useState({
    id: null,
    nome: '',
    descricao: '',
    ativo: true,
    prioridade: 1,
    origem_nodes: [],
    waypoint_nodes: [],
  });
  const [modoRegraFluxoAtivo, setModoRegraFluxoAtivo] = useState(false);
  const [etapaRegraFluxo, setEtapaRegraFluxo] = useState('origens'); 
  
  const [modalSalvarRegraFluxoVisivel, setModalSalvarRegraFluxoVisivel] = useState(false);

  const CIRCULACAO_OPCOES = ['interno', 'externo', 'misto'];

  const normalizarCirculacao = (v) => {
    const s = String(v || '').toLowerCase().trim();
    return CIRCULACAO_OPCOES.includes(s) ? s : 'interno';
  };
  
  const [selectedEdgeIds, setSelectedEdgeIds] = useState([]);

  const [circulacaoLoteNos, setCirculacaoLoteNos] = useState('interno');
  const [circulacaoLoteArestas, setCirculacaoLoteArestas] = useState('interno');

  // const [nodeEditCirculacao, setNodeEditCirculacao] = useState('interno');
  // const [edgeEditCirculacao, setEdgeEditCirculacao] = useState('interno');

  const distPointToSegment = (px, py, ax, ay, bx, by) => {
    const abx = bx - ax;
    const aby = by - ay;
    const apx = px - ax;
    const apy = py - ay;

    const abLen2 = abx * abx + aby * aby;
    if (abLen2 === 0) return Math.sqrt((px - ax) ** 2 + (py - ay) ** 2);

    let t = (apx * abx + apy * aby) / abLen2;
    t = Math.max(0, Math.min(1, t));

    const cx = ax + t * abx;
    const cy = ay + t * aby;
    return Math.sqrt((px - cx) ** 2 + (py - cy) ** 2);
  };

  const gerarCoberturaRotas = useCallback(() => {
    if (!mapData?.width || !mapData?.height) return;

    if (!edges.length || !nodes.length) {
      toast.info("Sem rotas para validar.");
      setCoverageRects([]);
      return;
    }

    const cell = 80;      // tamanho da grade (ajuste)
    const radius = 60;    // raio de cobertura (ajuste)

    const segs = edges
      .map(e => {
        const a = nodes.find(n => n.id === e.source);
        const b = nodes.find(n => n.id === e.target);
        if (!a || !b) return null;
        return { ax: a.x, ay: a.y, bx: b.x, by: b.y };
      })
      .filter(Boolean);

    const rects = [];
    const w = mapData.width;
    const h = mapData.height;

    for (let y = 0; y < h; y += cell) {
      for (let x = 0; x < w; x += cell) {
        const cx = x + cell / 2;
        const cy = y + cell / 2;

        let minD = Infinity;
        for (const s of segs) {
          const d = distPointToSegment(cx, cy, s.ax, s.ay, s.bx, s.by);
          if (d < minD) minD = d;
          if (minD <= radius) break;
        }

        const covered = minD <= radius;

        rects.push({
          key: `${x}_${y}`,
          x,
          y,
          w: Math.min(cell, w - x),
          h: Math.min(cell, h - y),
          fill: covered ? '#00c853' : '#ff5252'
        });
      }
    }

    setCoverageRects(rects);

    const coveredCount = rects.filter(r => r.fill === '#00c853').length;
    const pct = Math.round((coveredCount / rects.length) * 100);
    toast.info(`Cobertura aproximada: ${pct}%`);
  }, [mapData, edges, nodes]);

  const svgRef = useRef(null);

  const getSvgPointFromClientEvent = useCallback((event) => {
    if (!svgRef.current) return null;
    const svgPoint = svgRef.current.createSVGPoint();
    svgPoint.x = event.clientX;
    svgPoint.y = event.clientY;
    const ctm = svgRef.current.getScreenCTM()?.inverse();
    if (!ctm) return null;
    return svgPoint.matrixTransform(ctm);
  }, []);

  const getNodeLabel = useCallback((node) => {
    return node?.name || node?.description || node?.id || '';
  }, []);

  const resetRegraFluxoForm = useCallback(() => {
    setRegraFluxoForm({
      id: null,
      nome: '',
      descricao: '',
      ativo: true,
      prioridade: 1,
      origem_nodes: [],
      waypoint_nodes: [],
    });
  }, []);

  const abrirModalRegrasFluxo = useCallback(() => {
    resetRegraFluxoForm();
    setModalRegrasFluxoVisivel(true);
  }, [resetRegraFluxoForm]);

  const fecharModalRegrasFluxo = useCallback(() => {
    setModalRegrasFluxoVisivel(false);
    resetRegraFluxoForm();
  }, [resetRegraFluxoForm]);

  const editarRegraFluxo = useCallback((regra) => {
    setRegraFluxoForm({
      id: regra.id,
      nome: regra.nome || '',
      descricao: regra.descricao || '',
      ativo: regra.ativo !== false,
      prioridade: regra.prioridade || 1,
      origem_nodes: Array.isArray(regra.origem_nodes) ? regra.origem_nodes : [],
      waypoint_nodes: Array.isArray(regra.waypoint_nodes)
        ? regra.waypoint_nodes.map((w) => typeof w === 'string' ? w : w.node_id)
        : [],
    });

    setModoRegraFluxoAtivo(true);
    setEtapaRegraFluxo('origens');
    setModalSalvarRegraFluxoVisivel(false);

    toast.info('Regra carregada no mapa. Ajuste as origens e os waypoints clicando nos pontos.');
  }, []);

  const carregarRegrasFluxo = useCallback(async () => {
    try {
      const response = await fetchComAuth(`${api.API_URL}/rota/regras-fluxo/${feiraId}`);
      const data = await response.json();

      if (data?.success) {
        setRegrasFluxo(Array.isArray(data.data) ? data.data : []);
      } else {
        setRegrasFluxo([]);
      }
    } catch (error) {
      console.error('Erro ao carregar regras de fluxo:', error);
      toast.error('Erro ao carregar regras de fluxo.');
    }
  }, [feiraId]);

  useEffect(() => {
    const carregarDadosIniciais = async () => {
      setIsLoading(true);
      try {
        const responseMapa = await fetchComAuth(`${api.API_URL}/rota/mapa/${feiraId}`);
        const dataMapa = await responseMapa.json();
        if (dataMapa.status && dataMapa.data?.mapa?.mapa) {
          const mapa = dataMapa.data.mapa.mapa;
          setMapData({
            mapName: mapa.mapName,
            width: Number(mapa.width),
            height: Number(mapa.height),
            paths: mapa.paths,
          });
          setFundoUrl(dataMapa.data.fundoURL || "");
        } else {
           toast.warn("Nenhum mapa de estandes encontrado.");
           setIsLoading(false);
           return;
        }

        const responseEstandes = await fetchComAuth(`${api.API_URL}/rota/estandes/${feiraId}?refresh=1`);
        const dataEstandes = await responseEstandes.json();
        setEstandesCadastrados(dataEstandes.data.filter(e => e.hash_path !== "" && e.hash_path !== null) || []);

        const responseFeiraTiposEspaco = await fetchComAuth(`${api.API_URL}/feira/tiposEspaco/${feiraId}`);
        const dataFeiraTiposEspaco = await responseFeiraTiposEspaco.json();
        setTiposEspacoFeira(dataFeiraTiposEspaco.data || []);
        const responseGrafo = await fetchComAuthJson(`${api.API_URL}/rota/caminhos/${feiraId}?refresh=1`); // Ajuste a URL se necessário
        const dataGrafo = await responseGrafo.json();
        if (dataGrafo.status && dataGrafo.data) {
          const nodesAdaptados = dataGrafo.data.nodes.map(nodeDB => ({
            id: nodeDB.id,
            x: nodeDB.posicao_x,      // De 'posicao_x' para 'x'
            y: nodeDB.posicao_y,      // De 'posicao_y' para 'y'
            type: nodeDB.tipo,        // De 'tipo' para 'type'
            name: nodeDB.nome || nodeDB.descricao, // Usa 'nome' ou 'descricao' como 'name'
            description: nodeDB.descricao,
            tipo_espaco_id: (nodeDB.tipo_espaco_id === "" || nodeDB.tipo_espaco_id === undefined) 
              ? null 
              : nodeDB.tipo_espaco_id,// Mantém a descrição para tooltips,
            circulacao: normalizarCirculacao(nodeDB.circulacao),
          }));
        
          const edgesAdaptados = (dataGrafo.data.edges || []).map(edgeDB => ({
            id: `edge_${edgeDB.no_origem_id}_${edgeDB.no_destino_id}`, // Gera um ID de cliente
            source: edgeDB.no_origem_id,
            target: edgeDB.no_destino_id,
            sourceName: edgeDB.no_origem.descricao,
            targetName: edgeDB.no_destino.descricao,
            circulacao: normalizarCirculacao(edgeDB.circulacao),
          }));
       
          setNodes(nodesAdaptados);
          setEdges(edgesAdaptados);
        }


      } catch (err) {
        console.error("Erro ao carregar dados iniciais:", err);
        toast.error("Erro ao carregar dados do mapa ou rotas.");
      } finally {
        setIsLoading(false);
      }
    };
    if (feiraId) {
      carregarDadosIniciais();
      carregarRegrasFluxo();
    }
  }, [feiraId]);
  
  const handleDetectarDestinos = () => {
    if (!svgRef.current || estandesCadastrados.length === 0) {
      toast.warn("Nenhum estande cadastrado para detectar.");
      return;
    }

    const novosNosDestino = [];
    estandesCadastrados.forEach(estande => {
      const nome_expositor = estande.expositor ? estande.expositor.nome_mapa ?? estande.expositor.nome : '' ;
      const nome_destino = nome_expositor != '' ? nome_expositor + '-' + estande.nome : estande.nome;

      const pathElement = svgRef.current.querySelector(`path[data-hash="${estande.hash_path}"]`);
      
      if (pathElement) {
        const bbox = pathElement.getBBox();
        const nodeId = `dest_${estande.hash_path}`;

        // Verifica se um nó para este destino já não foi adicionado
        if (!nodes.some(n => n.id === nodeId)) {
            novosNosDestino.push({
              id: nodeId,
              x: bbox.x + bbox.width / 2,
              y: bbox.y + bbox.height / 2,
              type: 'destination',
              name: nome_destino || `Estande ${estande.id}`,
              description: nome_destino || `Estande ${estande.id}`,
            });
        }
      }
    });

    if (novosNosDestino.length > 0) {
      setNodes(prevNodes => [...prevNodes, ...novosNosDestino]);
      toast.success(`${novosNosDestino.length} destinos foram detectados e adicionados!`);
    } else {
      toast.info("Nenhum novo destino detectado. Eles podem já ter sido adicionados.");
    }
  };

  const cancelarSelecaoLigacao = useCallback(() => {
    setEdgeStartNode(null);
    setMousePos(null);
    toast.info("Seleção de ligação cancelada.");
  }, []);

  const handleMouseMove = useCallback((event) => {
    if (hoveredNode) {
      setHoverClientPos({ x: event.clientX, y: event.clientY });
    }

    if (isEditMode && ferramentaAtiva === 'move' && dragState) {
      const p = getSvgPointFromClientEvent(event);
      if (!p) return;
      const dx = p.x - dragState.startSvg.x;
      const dy = p.y - dragState.startSvg.y;

      setNodes(prev => prev.map(n => {
        if (!dragState.originals[n.id]) return n;
        const o = dragState.originals[n.id];
        return { ...n, x: o.x + dx, y: o.y + dy };
      }));
      return;
    }

    // Linha elástica (ligações)
    if (!isEditMode || ferramentaAtiva !== 'addEdge' || !edgeStartNode || !svgRef.current) {
      if (mousePos) setMousePos(null);
      return;
    }

    const pontoSVG = getSvgPointFromClientEvent(event);
    if (!pontoSVG) return;
    setMousePos({ x: pontoSVG.x, y: pontoSVG.y });
  }, [
    isEditMode,
    ferramentaAtiva,
    edgeStartNode,
    mousePos,
    dragState,
    hoveredNode,
    getSvgPointFromClientEvent
  ]);

  const gerarAutoLinkPreview = useCallback(() => {
    const hasEdgeBetween = (a, b) => edges.some(e =>
      (e.source === a && e.target === b) || (e.source === b && e.target === a)
    );

    const destinos = nodes.filter(n => n.type === 'destination');
    const caminhos = nodes.filter(n => n.type === 'intersection');

    if (!destinos.length || !caminhos.length) {
      toast.info("Precisa ter destinos e pontos de caminho para auto-ligar.");
      return;
    }

    const propostas = [];

    destinos.forEach(dest => {
      const jaLigado = edges.some(e => e.source === dest.id || e.target === dest.id);
      if (jaLigado) return;

      let melhor = null;
      let melhorDist = Infinity;

      caminhos.forEach(p => {
        const dx = p.x - dest.x;
        const dy = p.y - dest.y;
        const d = Math.sqrt(dx * dx + dy * dy);
        if (d < melhorDist) {
          melhorDist = d;
          melhor = p;
        }
      });

      if (melhor && !hasEdgeBetween(dest.id, melhor.id)) {
        propostas.push({
          id: `preview_${dest.id}_${melhor.id}`,
          source: dest.id,
          target: melhor.id
        });
      }
    });

    if (!propostas.length) {
      toast.info("Nenhum destino sem ligação encontrado para auto-ligar.");
      return;
    }

    setAutoLinkPreviewEdges(propostas);
    toast.success(`Prévia gerada: ${propostas.length} ligações.`);
  }, [nodes, edges]);

  const confirmarAutoLink = useCallback(() => {
    if (!autoLinkPreviewEdges.length) return;

    const getNodeName = (node) => node?.name || node?.description || node?.id;

    setEdges(prev => {
      const next = [...prev];

      autoLinkPreviewEdges.forEach(p => {
        const id1 = `edge_${p.source}_${p.target}`;
        const id2 = `edge_${p.target}_${p.source}`;
        const existe = next.some(e => e.id === id1 || e.id === id2);
        if (existe) return;

        const sourceNode = nodes.find(n => n.id === p.source);
        const targetNode = nodes.find(n => n.id === p.target);

        next.push({
          id: id1,
          source: p.source,
          target: p.target,
          sourceName: getNodeName(sourceNode),
          targetName: getNodeName(targetNode),
        });
      });

      return next;
    });

    setAutoLinkPreviewEdges([]);
    toast.success("Ligações confirmadas.");
  }, [autoLinkPreviewEdges, nodes]);

  const cancelarAutoLink = useCallback(() => {
    setAutoLinkPreviewEdges([]);
    toast.info("Prévia cancelada.");
  }, []);

  const salvarRegraFluxo = useCallback(async () => {
    const prioridadeConflitante = regrasFluxo.find(
      r => r.prioridade === Number(regraFluxoForm.prioridade) && r.id !== regraFluxoForm.id
    );

    if (prioridadeConflitante) {
      toast.error(`A prioridade ${regraFluxoForm.prioridade} já existe na regra "${prioridadeConflitante.nome}".`);
      return;
    }
    
    if (!regraFluxoForm.nome.trim()) {
      toast.warning('Informe o nome da regra.');
      return;
    }

    if (!regraFluxoForm.origem_nodes.length) {
      toast.warning('Selecione pelo menos uma origem.');
      return;
    }

    if (!regraFluxoForm.waypoint_nodes.length) {
      toast.warning('Selecione pelo menos um waypoint obrigatório.');
      return;
    }

    setIsSavingRegraFluxo(true);

    const payload = {
      feira_id: feiraId,
      nome: regraFluxoForm.nome.trim(),
      descricao: regraFluxoForm.descricao?.trim() || '',
      ativo: !!regraFluxoForm.ativo,
      prioridade: Number(regraFluxoForm.prioridade || 1),
      origens: regraFluxoForm.origem_nodes.map((nodeId) => ({ node_id: nodeId })),
      waypoints: regraFluxoForm.waypoint_nodes.map((nodeId, index) => ({
        node_id: nodeId,
        ordem: index + 1,
      })),
    };

    const url = regraFluxoForm.id
      ? `${api.API_URL}/rota/regras-fluxo/${regraFluxoForm.id}`
      : `${api.API_URL}/rota/regras-fluxo`;

    const method = regraFluxoForm.id ? 'PUT' : 'POST';

    try {
      const response = await fetchComAuthJson(url, {
        method,
        body: JSON.stringify(payload),
      });

      let data = response;
      let ok = true;

      if (response && typeof response.json === 'function') {
        data = await response.json();
        ok = response.ok;
      } else {
        ok = response?.success !== false;
      }

      if (!ok || !data?.success) {
        toast.error(data?.message || 'Erro ao salvar regra de fluxo.');
        return;
      }

      toast.success(
        regraFluxoForm.id
          ? 'Regra atualizada com sucesso.'
          : 'Regra criada com sucesso.'
      );

      await carregarRegrasFluxo();

      setModoRegraFluxoAtivo(false);
      setEtapaRegraFluxo('origens');
      setModalSalvarRegraFluxoVisivel(false);

      setRegraFluxoForm({
        id: null,
        nome: '',
        descricao: '',
        ativo: true,
        prioridade: 1,
        origem_nodes: [],
        waypoint_nodes: [],
      });
  } catch (error) {
    console.error('Erro ao salvar regra de fluxo:', error);
    toast.error(`Erro ao salvar regra de fluxo: ${error?.message || 'falha inesperada'}`);
  } finally {
    setIsSavingRegraFluxo(false);
  }
}, [regraFluxoForm, feiraId, carregarRegrasFluxo]);

  const excluirRegraFluxo = useCallback(async (regraId) => {
    const confirmar = window.confirm('Deseja realmente excluir esta regra de fluxo?');
    if (!confirmar) return;

    try {
      const response = await fetchComAuthJson(`${api.API_URL}/rota/regras-fluxo/${regraId}`, {
        method: 'DELETE',
      });

      const data = await response.json();

      if (!response.ok || !data?.success) {
        toast.error(data?.message || 'Erro ao excluir regra.');
        return;
      }

      toast.success('Regra excluída com sucesso.');
      await carregarRegrasFluxo();
    } catch (error) {
      console.error('Erro ao excluir regra:', error);
      toast.error('Erro ao excluir regra.');
    }
  }, [carregarRegrasFluxo]);

  const alterarStatusRegraFluxo = useCallback(async (regra) => {
    try {
      const response = await fetchComAuthJson(`${api.API_URL}/rota/regras-fluxo/${regra.id}/status`, {
        method: 'PATCH',
        body: JSON.stringify({
          ativo: !regra.ativo,
        }),
      });

      const data = await response.json();

      if (!response.ok || !data?.success) {
        toast.error(data?.message || 'Erro ao atualizar status da regra.');
        return;
      }

      toast.success(`Regra ${!regra.ativo ? 'ativada' : 'desativada'} com sucesso.`);
      await carregarRegrasFluxo();
    } catch (error) {
      console.error('Erro ao atualizar status da regra:', error);
      toast.error('Erro ao atualizar status da regra.');
    }
  }, [carregarRegrasFluxo]);

  useEffect(() => {
    if (!dragState) return;
    const onUp = () => setDragState(null);
    window.addEventListener('mouseup', onUp);
    window.addEventListener('blur', onUp);
    return () => {
      window.removeEventListener('mouseup', onUp);
      window.removeEventListener('blur', onUp);
    };
  }, [dragState]);

  const verificarPontosIsolados = useCallback(() => {
    // Cria um Set com todos os IDs de nós que aparecem em alguma aresta (origem ou destino)
    const idsConectados = new Set();
    edges.forEach(edge => {
      idsConectados.add(edge.source);
      idsConectados.add(edge.target);
    });

    // Filtra os nós atuais para encontrar os que NÃO estão no Set de conectados
    const pontosIsolados = nodes.filter(node => !idsConectados.has(node.id));
    
    // Log para depuração fácil no console do navegador
    if (pontosIsolados.length > 0) {
      console.warn("Pontos isolados encontrados:", pontosIsolados);
    }

    return pontosIsolados.length;
  }, [nodes, edges]);

  const detectarDestinosSemLigacao = useCallback(() => {
    const destinos = nodes.filter(n => n.type === 'destination');
    
    const semLigacao = destinos.filter(dest => {
      return !edges.some(edge => edge.source === dest.id || edge.target === dest.id);
    });

    if (semLigacao.length === 0) {
      toast.success("Todos os destinos possuem ao menos uma ligação! ✅");
    } else {
      toast.warning(`Atenção: ${semLigacao.length} destino(s) estão isolados.`);
    }
    return semLigacao;
  }, [nodes, edges]);

  const handleMapClick = useCallback((event) => {
    if (!isEditMode || ferramentaAtiva === 'pan') return;

    if (isEditMode && ferramentaAtiva === 'move') {
      if (!(event.shiftKey || event.metaKey)) {
        setSelectedNodeIds([]);
        setSelectedEdgeIds([]); 
      }
      return;
    }
    
    const svgPoint = svgRef.current.createSVGPoint();
    svgPoint.x = event.clientX;
    svgPoint.y = event.clientY;
    const ctm = svgRef.current.getScreenCTM().inverse();
    const pontoCorreto = svgPoint.matrixTransform(ctm);
    
    setPontoTemporarioCoords({ x: pontoCorreto.x, y: pontoCorreto.y });

    if (ferramentaAtiva === 'addNode') {
      // Se estiver no modo contínuo e já tiver uma descrição, pula o modal
      if (modoContinuo && descricaoNovoPonto) {
        const newNode = {
          id: `node_${Date.now()}`,
          x: pontoCorreto.x,
          y: pontoCorreto.y,
          type: 'intersection',
          description: descricaoNovoPonto,
          circulacao: 'interno'
        };
        setNodes(prev => [...prev, newNode]);
      } else {
        setModalPontoVisivel(true);
      }
    } else if (ferramentaAtiva === 'markDestination') {
      // Se estiver no modo contínuo e já tiver nome/tipo, pula o modal
      if (modoContinuo && nomeNovoDestino) {
        const newNode = {
          id: `dest_manual_${Date.now()}`,
          x: pontoCorreto.x,
          y: pontoCorreto.y,
          type: 'destination',
          description: nomeNovoDestino,
          tipo_espaco_id: tipoEspacoSelecionado === "" ? null : tipoEspacoSelecionado
        };
        setNodes(prev => [...prev, newNode]);
      } else {
        setModalDestinoVisivel(true);
      }
    }
  }, [ferramentaAtiva, isEditMode, modoContinuo, descricaoNovoPonto, nomeNovoDestino, tipoEspacoSelecionado]);

  const handleSalvarNovoPonto = (e) => {
    e.preventDefault(); 
    if (!pontoTemporarioCoords) return;

    const newNode = {
      id: `node_${Date.now()}`,
      x: pontoTemporarioCoords.x,
      y: pontoTemporarioCoords.y,
      type: 'intersection',
      description: descricaoNovoPonto || "Ponto de passagem" // Adiciona a descrição
    };
    setNodes(prev => [...prev, newNode]);
    toast.success("Ponto de rota adicionado!");
    setModalPontoVisivel(false); // Fecha o modal
  };

  const handleSalvarNovoDestino = (e) => {
    e.preventDefault(); 
    if (!pontoTemporarioCoords || !nomeNovoDestino) {
        toast.error("O nome do destino é obrigatório.");
        return;
    };
    
    const newNode = {
      id: `dest_manual_${Date.now()}`,
      x: pontoTemporarioCoords.x,
      y: pontoTemporarioCoords.y,
      type: 'destination',
      description: nomeNovoDestino,
      tipo_espaco_id: tipoEspacoSelecionado === "" ? null : tipoEspacoSelecionado
    };

    setNodes(prev => [...prev, newNode]);
    toast.success(`Destino "${nomeNovoDestino}" adicionado.`);
    setNomeNovoDestino("");
    setTipoEspacoSelecionado("");
    setModalDestinoVisivel(false);
    setModalDestinoVisivel(false); // Fecha o modal
  };

  const toggleNodeInArray = useCallback((arr, nodeId) => {
    return arr.includes(nodeId)
      ? arr.filter((id) => id !== nodeId)
      : [...arr, nodeId];
  }, []);

  const handleNodeClick = useCallback((e, nodeId) => {
    if (!isEditMode) return;
    e.stopPropagation();

    if (modoRegraFluxoAtivo) {
      e?.stopPropagation?.();

      if (etapaRegraFluxo === 'origens') {
        setRegraFluxoForm((prev) => ({
          ...prev,
          origem_nodes: toggleNodeInArray(prev.origem_nodes, nodeId),
        }));
        return;
      }

      if (etapaRegraFluxo === 'waypoints') {
        setRegraFluxoForm((prev) => ({
          ...prev,
          waypoint_nodes: toggleNodeInArray(prev.waypoint_nodes, nodeId),
        }));
        return;
      }
    }

    if (ferramentaAtiva === 'move') {
      setEdgeStartNode(null);

      const multi = e.shiftKey || e.metaKey;

      setSelectedNodeIds(prev => {
        if (!multi) return [nodeId];              // clique normal: seleção única
        if (prev.includes(nodeId)) return prev.filter(id => id !== nodeId); // toggle off
        return [...prev, nodeId];                // adiciona mantendo ordem
      });

      return;
    }

    if (ferramentaAtiva === 'addEdge') {
      if (!edgeStartNode) {
        setEdgeStartNode(nodeId);
        toast.info(`Ponto inicial selecionado. Clique em outro ponto para criar a ligação.`);
      } else {
        if (edgeStartNode === nodeId) return;
        const edgeId1 = `edge_${edgeStartNode}_${nodeId}`;
        const edgeId2 = `edge_${nodeId}_${edgeStartNode}`;
        const edgeExists = edges.some(edge => edge.id === edgeId1 || edge.id === edgeId2);
        
        if (!edgeExists) {
            // *** INÍCIO DA ALTERAÇÃO ***
            const sourceNode = nodes.find(n => n.id === edgeStartNode);
            const targetNode = nodes.find(n => n.id === nodeId);

            // Função para obter o nome do nó (seja 'name' ou 'description')
            const getNodeName = (node) => node.name || node.description || node.id;

            if (sourceNode && targetNode) {
              const newEdge = { 
                id: edgeId1, 
                source: edgeStartNode, 
                target: nodeId,
                // Adicionamos os nomes para exibição
                sourceName: getNodeName(sourceNode), 
                targetName: getNodeName(targetNode),
                circulacao: 'interno'
              };
              setEdges(prev => [...prev, newEdge]);
            }
            // *** FIM DA ALTERAÇÃO ***
        }
        
        if (modoContinuo) {
          setEdgeStartNode(nodeId); 
        } else {
          setEdgeStartNode(null); // Comportamento padrão: para a ligação
        }
      }
    } else if (ferramentaAtiva === 'delete') {
      setNodes(prev => prev.filter(n => n.id !== nodeId));
      setEdges(prev => prev.filter(e => e.source !== nodeId && e.target !== nodeId));
      //toast.warn(`Nó ${nodeId} e seus caminhos foram excluídos.`);
      setEdgeStartNode(null); // Limpa qualquer nó inicial
    }
    
    else if (ferramentaAtiva === 'markDestination') {
      const nodeToUpdate = nodes.find(n => n.id === nodeId);
      if (nodeToUpdate && nodeToUpdate.type === 'intersection') {
        const nomeDestino = prompt("Digite o nome para este destino:", nodeToUpdate.name || "");
        if (nomeDestino !== null) {
          const updatedNodes = nodes.map(n => 
            n.id === nodeId ? { ...n, type: 'destination', name: nomeDestino } : n
          );
          setNodes(updatedNodes);
          toast.success(`Ponto atualizado para destino: "${nomeDestino}"`);
        }
      }
    }
  }, [ferramentaAtiva, edgeStartNode, edges, nodes, isEditMode, modoRegraFluxoAtivo,
  etapaRegraFluxo,
  toggleNodeInArray,]);

  const handleNodeMouseDown = useCallback((e, nodeId) => {
    if (!isEditMode || ferramentaAtiva !== 'move') return;
if (modoRegraFluxoAtivo) return;
    
    if (e.shiftKey || e.metaKey) return;

    const p = getSvgPointFromClientEvent(e);
    if (!p) return;

    const ids = (Array.isArray(selectedNodeIds) && selectedNodeIds.includes(nodeId))
      ? selectedNodeIds
      : [nodeId];

    // garante que o nó clicado esteja selecionado
    if (!Array.isArray(selectedNodeIds) || !selectedNodeIds.includes(nodeId)) {
      setSelectedNodeIds([nodeId]);
    }

  const originals = {};
  ids.forEach(id => {
    const n = nodes.find(x => x.id === id);
    if (n) originals[id] = { x: n.x, y: n.y };
  });

  setDragState({ startSvg: { x: p.x, y: p.y }, originals, ids });
  }, [isEditMode, ferramentaAtiva, selectedNodeIds, nodes, getSvgPointFromClientEvent]);

  useEffect(() => {
    if (!dragState) return;

    const stop = () => setDragState(null);

    window.addEventListener('mouseup', stop);
    window.addEventListener('mouseleave', stop);

    return () => {
      window.removeEventListener('mouseup', stop);
      window.removeEventListener('mouseleave', stop);
    };
  }, [dragState]);

  const alinharHorizontal = useCallback(() => {
    const ids = Array.from(selectedNodeIds);
    if (ids.length < 2) {
      toast.info("Selecione pelo menos 2 pontos para alinhar.");
      return;
    }
    const base = nodes.find(n => n.id === ids[0]);
    if (!base) return;

    setNodes(prev => prev.map(n => ids.includes(n.id) ? { ...n, y: base.y } : n));
    toast.success("Alinhado horizontalmente.");
  }, [selectedNodeIds, nodes]);

  const alinharVertical = useCallback(() => {
    const ids = Array.from(selectedNodeIds);
    if (ids.length < 2) {
      toast.info("Selecione pelo menos 2 pontos para alinhar.");
      return;
    }
    const base = nodes.find(n => n.id === ids[0]);
    if (!base) return;

    setNodes(prev => prev.map(n => ids.includes(n.id) ? { ...n, x: base.x } : n));
    toast.success("Alinhado verticalmente.");
  }, [selectedNodeIds, nodes]);

  const ligarSelecionados = useCallback(() => {
    const ids = Array.isArray(selectedNodeIds) ? selectedNodeIds : Array.from(selectedNodeIds || []);
    if (ids.length < 2) {
      toast.info("Selecione pelo menos 2 pontos para ligar.");
      return;
    }

    const jaExiste = (a, b) => edges.some(e =>
      (e.source === a && e.target === b) || (e.source === b && e.target === a)
    );

    const getNodeName = (id) => {
      const n = nodes.find(x => x.id === id);
      return n?.name || n?.description || n?.id || id;
    };

    const novas = [];
    for (let i = 0; i < ids.length; i++) {
      for (let j = i + 1; j < ids.length; j++) {
        const a = ids[i];
        const b = ids[j];
        if (a === b) continue; // evita loop em si mesmo
        if (jaExiste(a, b)) continue;

        novas.push({
          id: `edge_${a}_${b}`,
          source: a,
          target: b,
          sourceName: getNodeName(a),
          targetName: getNodeName(b),
        });
      }
    }

    if (!novas.length) {
      toast.info("Nenhuma ligação nova foi criada (talvez já existam).");
      return;
    }

    setEdges(prev => [...prev, ...novas]);
    toast.success(`${novas.length} ligações criadas.`);
  }, [selectedNodeIds, edges, nodes]);

  const aplicarAutoLink = useCallback(() => {
    const propostasAplicar = autoLinkPropostas.filter(p => autoLinkSelecionadas.has(p.key));
    if (propostasAplicar.length === 0) {
      toast.info('Nenhuma ligação selecionada.');
      return;
    }

    const novasEdges = [];
    propostasAplicar.forEach((p) => {
      const edgeId = `edge_${p.source}_${p.target}`;
      const edgeId2 = `edge_${p.target}_${p.source}`;
      const exists = edges.some(e => e.id === edgeId || e.id === edgeId2);
      if (exists) return;
      const sourceNode = nodes.find(n => n.id === p.source);
      const targetNode = nodes.find(n => n.id === p.target);
      novasEdges.push({
        id: edgeId,
        source: p.source,
        target: p.target,
        sourceName: getNodeLabel(sourceNode),
        targetName: getNodeLabel(targetNode)
      });
    });

    if (novasEdges.length > 0) {
      setEdges(prev => [...prev, ...novasEdges]);
      toast.success(`${novasEdges.length} ligação(ões) aplicada(s).`);
    } else {
      toast.info('Nenhuma ligação nova foi aplicada.');
    }

    setModalAutoLinkVisivel(false);
    setAutoLinkPreviewEdges([]);
  }, [autoLinkPropostas, autoLinkSelecionadas, edges, nodes, getNodeLabel]);

  const handleStandClick = useCallback((e, standData) => {
    if (!isEditMode) return;
      e.stopPropagation();
      let nodeId = `dest_${standData.hash}`;

      // Adiciona um nó do tipo "destination" para o estande se ele não existir
      if (!nodes.some(n => n.id === nodeId)) {
        const newNode = {
          id: nodeId,
          x: standData.centerX,
          y: standData.centerY,
          type: 'destination',
          name: standData.nome // Opcional: guardar o nome do estande
        };
        setNodes(prev => [...prev, newNode]);
      }
      
      // Usa a mesma lógica de clique em nó para criar ligações
      handleNodeClick(e, nodeId);

  }, [nodes, handleNodeClick, isEditMode]);

  const handleSaveRoutes = async () => {
    setIsLoading(true);
    try {
      const edgesWithWeights = edges.map(edge => {
        const sourceNode = nodes.find(n => n.id === edge.source);
        const targetNode = nodes.find(n => n.id === edge.target);
        
        if (!sourceNode || !targetNode) return null;

        const weight = Math.sqrt(
          Math.pow(targetNode.x - sourceNode.x, 2) + 
          Math.pow(targetNode.y - sourceNode.y, 2)
        );
        
        return { ...edge, circulacao: normalizarCirculacao(edge.circulacao), weight }; 
      }).filter(Boolean);

      const dataToSend = {
        feira_id: feiraId,
        nodes: nodes.map(n => ({
          ...n,
          circulacao: normalizarCirculacao(n.circulacao), // <-- NOVO
        })),
        edges: edgesWithWeights,
      };

      const response = await fetchComAuthJson(`${api.API_URL}/rota/caminhos/${feiraId}`, {
        method: "POST", // Usar POST é comum para operações de "salvar/sincronizar".
        body: JSON.stringify(dataToSend),
      });

      if (response.ok) {
        toast.success("Malha de rotas salva com sucesso!");
      } else {
        toast.error("Erro ao salvar a malha de rotas.");
      }
    } catch (err) {
      toast.error("Falha na comunicação com o servidor.");
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleSyncMap = async () => {
    const confirmacao = window.confirm("Isso atualizará o mapa para todos os usuários. Continuar?");
    
    if (confirmacao) {
      try {
        await fetchComAuthJson(`${api.API_URL}/admin/cache/limpar-feira/${feiraId}`, {
          method: "POST"
        });

        toast.success("Mapa sincronizado com sucesso!");
      } catch (error) {
        toast.error("Erro ao sincronizar mapa.");
      }
    }
  }

  const handleDeleteNodeFromList = (nodeId) => {
    setNodes(prev => prev.filter(n => n.id !== nodeId));
    setEdges(prev => prev.filter(e => e.source !== nodeId && e.target !== nodeId));
  };
    
  const handleDeleteEdgeFromList = (edgeId) => {
    setEdges(prev => prev.filter(e => e.id !== edgeId));
    toast.warn(`Caminho ${edgeId} foi excluído.`);
  };

  const handleEdgeClick = useCallback((e, edgeId) => {
    if (!isEditMode) return;
    e.stopPropagation();

    if (ferramentaAtiva === 'delete') {
      handleDeleteEdgeFromList(edgeId);
      return;
    }

    if (ferramentaAtiva === 'move') {
      const multi = e.shiftKey || e.metaKey;

      setSelectedEdgeIds(prev => {
        if (!multi) {
          return prev.length === 1 && prev[0] === edgeId ? [] : [edgeId];
        }

        if (prev.includes(edgeId)) return prev.filter(id => id !== edgeId);
        return [...prev, edgeId];
      });
    }
  }, [ferramentaAtiva, isEditMode, handleDeleteEdgeFromList]);

  const aplicarCirculacaoNosSelecionados = useCallback((circulacao) => {
    const ids = Array.isArray(selectedNodeIds) ? selectedNodeIds : Array.from(selectedNodeIds || []);
    if (!ids.length) {
      toast.info("Selecione pelo menos 1 ponto.");
      return;
    }

    const valor = normalizarCirculacao(circulacao);

    setNodes(prev =>
      prev.map(n => ids.includes(n.id) ? { ...n, circulacao: valor } : n)
    );

    toast.success(`Circulação "${valor}" aplicada em ${ids.length} ponto(s).`);
  }, [selectedNodeIds]);

  const aplicarCirculacaoArestasSelecionadas = useCallback((circulacao) => {
    const ids = Array.isArray(selectedEdgeIds) ? selectedEdgeIds : Array.from(selectedEdgeIds || []);
    if (!ids.length) {
      toast.info("Selecione pelo menos 1 caminho.");
      return;
    }

    const valor = normalizarCirculacao(circulacao);

    setEdges(prev =>
      prev.map(e => ids.includes(e.id) ? { ...e, circulacao: valor } : e)
    );

    toast.success(`Circulação "${valor}" aplicada em ${ids.length} caminho(s).`);
  }, [selectedEdgeIds]);

  const iniciarNovaRegraFluxoNoMapa = useCallback(() => {
    setRegraFluxoForm({
      id: null,
      nome: '',
      descricao: '',
      ativo: true,
      prioridade: 1,
      origem_nodes: [],
      waypoint_nodes: [],
    });

    setModoRegraFluxoAtivo(true);
    setEtapaRegraFluxo('origens');
    setModalSalvarRegraFluxoVisivel(false);

    toast.info('Modo regra de fluxo ativado. Clique nos pontos de ORIGEM no mapa.');
  }, []);

  const cancelarNovaRegraFluxoNoMapa = useCallback(() => {
    setModoRegraFluxoAtivo(false);
    setEtapaRegraFluxo('origens');
    setModalSalvarRegraFluxoVisivel(false);

    setRegraFluxoForm((prev) => ({
      ...prev,
      id: null,
      nome: '',
      descricao: '',
      ativo: true,
      prioridade: 1,
      origem_nodes: [],
      waypoint_nodes: [],
    }));

    toast.info('Criação da regra cancelada.');
  }, []);

  const avancarEtapaRegraFluxo = useCallback(() => {
    if (!regraFluxoForm.origem_nodes.length) {
      toast.warning('Selecione pelo menos uma origem no mapa.');
      return;
    }

    setEtapaRegraFluxo('waypoints');
    toast.info('Agora clique nos pontos que a rota deve passar obrigatoriamente.');
  }, [regraFluxoForm.origem_nodes]);

  const voltarEtapaRegraFluxo = useCallback(() => {
    setEtapaRegraFluxo('origens');
    toast.info('Voltando para seleção das origens.');
  }, []);

  const limparSelecaoRegraFluxo = useCallback(() => {
    setRegraFluxoForm((prev) => ({
      ...prev,
      origem_nodes: [],
      waypoint_nodes: [],
    }));
    setEtapaRegraFluxo('origens');
    toast.info('Seleção da regra foi limpa.');
  }, []);

  const abrirModalSalvarRegraFluxo = useCallback(() => {
    if (!regraFluxoForm.origem_nodes.length) {
      toast.warning('Selecione pelo menos uma origem.');
      return;
    }

    if (!regraFluxoForm.waypoint_nodes.length) {
      toast.warning('Selecione pelo menos um waypoint obrigatório.');
      return;
    }

    setModalSalvarRegraFluxoVisivel(true);
  }, [regraFluxoForm.origem_nodes, regraFluxoForm.waypoint_nodes]);

  const fecharModalSalvarRegraFluxo = useCallback(() => {
    setModalSalvarRegraFluxoVisivel(false);
  }, []);

  if (isLoading) {
    return <p>Carregando dados do mapa...</p>;
  }

  if (!mapData) {
    return <p>Mapa não encontrado. Por favor, cadastre um mapa na aba "Cadastro de Estandes".</p>
  }

  return (
    <div>
      <ToastContainer closeButton={false} />
        <CardHeader>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
             <Button 
              color={isEditMode ? "warning" : "success"} 
              onClick={() => {
                setIsEditMode(!isEditMode);
                if(!isEditMode) setFerramentaAtiva('addNode');
                else setFerramentaAtiva('pan');
              }}
            >
              <i className={`fa-solid ${isEditMode ? "fa-eye" : "fa-pencil"} me-1`}></i>
              {isEditMode ? "Sair da Edição" : "Editar Mapa"}
            </Button>
          </div>
        </CardHeader>

        <div className="roteamento-editor">
  {isEditMode && (
    <div className="editor-toolbar-wrapper">
      <div className="editor-toolbar-grid">
        {/* Ferramentas */}
        <div className="toolbar-card toolbar-card-span-4">
          <div className="toolbar-card-title">Ferramentas do mapa</div>
          <div className="toolbar-actions">
            <Button
              color={ferramentaAtiva === 'pan' ? 'primary' : 'light'}
              onClick={() => setFerramentaAtiva('pan')}
              title="Navegar no mapa"
            >
              <i className="fa-solid fa-hand me-1"></i> Mover mapa
            </Button>

            <Button
              color={ferramentaAtiva === 'addNode' ? 'success' : 'light'}
              onClick={() => setFerramentaAtiva('addNode')}
              title="Adicionar ponto"
            >
              <i className="fa-solid fa-circle-plus me-1"></i> Adicionar ponto
            </Button>

            <Button
              color={ferramentaAtiva === 'addEdge' ? 'primary' : 'light'}
              onClick={() => {
                setFerramentaAtiva('addEdge');
                setEdgeStartNode(null);
              }}
              title="Ligar pontos"
            >
              <i className="fa-solid fa-share-nodes me-1"></i> Ligar ponto
            </Button>

            <Button
              color={ferramentaAtiva === 'markDestination' ? 'success' : 'light'}
              onClick={() => setFerramentaAtiva('markDestination')}
              title="Marcar destino"
            >
              <i className="fa-solid fa-flag-checkered me-1"></i> Adicionar destino
            </Button>

            <Button
              color={ferramentaAtiva === 'delete' ? 'danger' : 'light'}
              onClick={() => setFerramentaAtiva('delete')}
              title="Excluir"
            >
              <i className="fa-solid fa-trash-can me-1"></i> Excluir
            </Button>

            <Button
              color={ferramentaAtiva === 'move' ? 'primary' : 'light'}
              outline={ferramentaAtiva !== 'move'}
              onClick={() => {
                setFerramentaAtiva('move');
                setEdgeStartNode(null);
                setMousePos(null);
              }}
              title="Mover ou selecionar (Shift)"
            >
              <i className="fa-solid fa-arrows-up-down-left-right me-1"></i> Selecionar / mover
            </Button>
          </div>
        </div>

        {/* Organização */}
        <div className="toolbar-card toolbar-card-span-2">
          <div className="toolbar-card-title">Organização</div>
          <div className="toolbar-actions">
            <Button
              color="light"
              onClick={alinharHorizontal}
              disabled={selectedNodeIds.length < 2}
              title="Alinhar horizontal"
            >
              <i className="fa-solid fa-align-center me-1"></i> Alinhar H
            </Button>

            <Button
              color="light"
              onClick={alinharVertical}
              disabled={selectedNodeIds.length < 2}
              title="Alinhar vertical"
            >
              <i className="fa-solid fa-align-center fa-rotate-90 me-1"></i> Alinhar V
            </Button>

            <Button
              color="light"
              onClick={ligarSelecionados}
              disabled={selectedNodeIds.length < 2}
              title="Ligar todos selecionados"
            >
              <i className="fa-solid fa-link me-1"></i> Ligar todos
            </Button>
          </div>
        </div>

        {/* Automação */}
        <div className="toolbar-card toolbar-card-span-3">
          <div className="toolbar-card-title">Automação e validação</div>
          <div className="toolbar-actions">
            <Button color="light" onClick={handleDetectarDestinos} title="Detectar destinos automaticamente">
              <i className="fa-solid fa-wand-magic-sparkles me-1"></i> Detectar destinos
            </Button>

            <Button color="light" onClick={gerarAutoLinkPreview} title="Gerar ligações automáticas">
              <i className="fa-solid fa-wand-sparkles me-1"></i> Detectar ligações
            </Button>

            {autoLinkPreviewEdges.length > 0 && (
              <>
                <Button color="success" onClick={confirmarAutoLink}>
                  <i className="fa-solid fa-check me-1"></i> Confirmar
                </Button>
                <Button color="danger" outline onClick={cancelarAutoLink}>
                  <i className="fa-solid fa-xmark me-1"></i> Cancelar
                </Button>
              </>
            )}

            <Button
              color="light"
              onClick={() => {
                const isolados = verificarPontosIsolados();
                if (isolados > 0) toast.warning(`${isolados} pontos isolados.`);
                else toast.success('Tudo conectado!');
              }}
              title="Checar pontos isolados"
            >
              <i className="fa-solid fa-circle-exclamation me-1"></i> Checar ligações
            </Button>

            <Button color="light" onClick={detectarDestinosSemLigacao} title="Checar destinos sem rota">
              <i className="fa-solid fa-link-slash me-1"></i> Checar destinos
            </Button>

            <Button color="light" onClick={gerarCoberturaRotas} title="Visualizar cobertura">
              <i className="fa-solid fa-layer-group me-1"></i> Cobertura
            </Button>

            {coverageRects.length > 0 && (
              <Button color="light" onClick={() => setCoverageRects([])}>
                <i className="fa-solid fa-eraser me-1"></i> Limpar cobertura
              </Button>
            )}
          </div>
        </div>

        {/* Configurações */}
        <div className="toolbar-card toolbar-card-span-3">
          <div className="toolbar-card-title">Configurações</div>

          <div className="toolbar-actions toolbar-actions-stack">
            <div className="toolbar-inline-field">
              <label className="switch-inline">
                <input
                  type="checkbox"
                  checked={modoContinuo}
                  onChange={() => setModoContinuo(!modoContinuo)}
                />
                <span>Modo contínuo</span>
              </label>
            </div>

            {edgeStartNode && ferramentaAtiva === 'addEdge' && (
              <Button size="sm" color="warning" onClick={cancelarSelecaoLigacao}>
                Limpar link
              </Button>
            )}

            <div className="toolbar-field-card">
              <Label>Circulação dos pontos</Label>
              <Input
                type="select"
                bsSize="sm"
                value={circulacaoLoteNos}
                onChange={(e) => setCirculacaoLoteNos(e.target.value)}
              >
                <option value="interno">Interno</option>
                <option value="externo">Externo</option>
                <option value="misto">Misto</option>
              </Input>

              <Button
                size="sm"
                color="secondary"
                outline
                onClick={() => aplicarCirculacaoNosSelecionados(circulacaoLoteNos)}
                disabled={!isEditMode || selectedNodeIds.length < 1}
                title="Aplica circulação nos pontos selecionados"
              >
                <i className="fa-solid fa-location-dot me-1"></i>
                Aplicar nos pontos
              </Button>
            </div>

            <div className="toolbar-field-card">
              <Label>Circulação dos caminhos</Label>
              <Input
                type="select"
                bsSize="sm"
                value={circulacaoLoteArestas}
                onChange={(e) => setCirculacaoLoteArestas(e.target.value)}
              >
                <option value="interno">Interno</option>
                <option value="externo">Externo</option>
                <option value="misto">Misto</option>
              </Input>

              <Button
                size="sm"
                color="secondary"
                outline
                onClick={() => aplicarCirculacaoArestasSelecionadas(circulacaoLoteArestas)}
                disabled={!isEditMode || selectedEdgeIds.length < 1}
                title="Aplica circulação nos caminhos selecionados"
              >
                <i className="fa-solid fa-route me-1"></i>
                Aplicar nos caminhos
              </Button>
            </div>
          </div>
        </div>

        {/* Regras e persistência */}
        <div className="toolbar-card toolbar-card-highlight toolbar-card-span-12">
          <div className="toolbar-card-title">Regras e persistência</div>

          <div className="toolbar-actions">
            <Button
              color={modoRegraFluxoAtivo ? 'warning' : 'primary'}
              outline
              onClick={modoRegraFluxoAtivo ? cancelarNovaRegraFluxoNoMapa : iniciarNovaRegraFluxoNoMapa}
              title="Criar regra de fluxo no mapa"
            >
              <i className="fa-solid fa-diagram-next me-1"></i>
              {modoRegraFluxoAtivo ? 'Cancelar regra no mapa' : 'Nova regra no mapa'}
            </Button>

            <Button
              color="primary"
              outline
              onClick={async () => {
                await carregarRegrasFluxo();
                abrirModalRegrasFluxo();
              }}
              title="Gerenciar regras cadastradas"
            >
              <i className="fa-solid fa-list-check me-1"></i>
              Gerenciar regras
            </Button>

            <div className="toolbar-spacer"></div>

            <Button
              color="success"
              onClick={handleSaveRoutes}
              disabled={isLoading}
              className="toolbar-save-btn"
            >
              <i className="fa-solid fa-save me-1"></i>
              {isLoading ? 'Salvando...' : 'Salvar rotas'}
            </Button>

            <Button
              color="success"
              onClick={handleSyncMap}
              disabled={isLoading}
              className="toolbar-save-btn"
            >
              <i className="fa-solid fa-refresh me-1"></i>
              {isLoading ? 'Atualizando...' : 'Atualizar cache'}
            </Button>

          </div>
        </div>
      </div>
    </div>
  )}

  <div className="mapa-stage">
    {modoRegraFluxoAtivo && (
      <div className="regra-fluxo-bar">
        <div className="regra-fluxo-bar__left">
          <div className="regra-fluxo-bar__title">Modo Regra de Fluxo</div>

          <div className="regra-fluxo-bar__chips">
            <span className={`badge ${etapaRegraFluxo === 'origens' ? 'bg-primary' : 'bg-secondary'}`}>
              Selecionando origens
            </span>

            <span className={`badge ${etapaRegraFluxo === 'waypoints' ? 'bg-success' : 'bg-secondary'}`}>
              Selecionando passagem obrigatória
            </span>

            <span className="badge bg-primary">
              Origens: {regraFluxoForm.origem_nodes.length}
            </span>

            <span className="badge bg-success">
              Waypoints: {regraFluxoForm.waypoint_nodes.length}
            </span>
          </div>
        </div>

        <div className="regra-fluxo-bar__actions">
          {etapaRegraFluxo === 'origens' ? (
            <Button size="sm" color="success" onClick={avancarEtapaRegraFluxo}>
              Avançar
            </Button>
          ) : (
            <Button size="sm" color="secondary" outline onClick={voltarEtapaRegraFluxo}>
              Voltar
            </Button>
          )}

          <Button size="sm" color="secondary" outline onClick={limparSelecaoRegraFluxo}>
            Limpar
          </Button>

          <Button size="sm" color="primary" onClick={abrirModalSalvarRegraFluxo}>
            Salvar regra
          </Button>
        </div>
      </div>
    )}

    <MapaRoteamento
      ref={svgRef}
      mapData={mapData}
      fundoUrl={fundoUrl}
      estandesCadastrados={estandesCadastrados}
      tiposEspacoFeira={tiposEspacoFeira}
      nodes={nodes}
      edges={edges}
      previewEdges={autoLinkPreviewEdges}
      onMapClick={handleMapClick}
      onNodeClick={handleNodeClick}
      onNodeMouseDown={handleNodeMouseDown}
      onEdgeClick={handleEdgeClick}
      onStandClick={handleStandClick}
      ferramentaAtiva={ferramentaAtiva}
      isEditMode={isEditMode}
      mousePos={mousePos}
      onMouseMove={handleMouseMove}
      edgeStartNode={edgeStartNode}
      selectedNodeIds={selectedNodeIds}
      selectedEdgeIds={selectedEdgeIds}
      coverageRects={coverageRects}
      regraOrigemIds={regraFluxoForm.origem_nodes}
      regraWaypointIds={regraFluxoForm.waypoint_nodes}
      modoSelecaoRegra={modoRegraFluxoAtivo ? etapaRegraFluxo : null}
    />

    {hoveredNode && hoverClientPos && (
      <div
        style={{
          position: 'fixed',
          left: hoverClientPos.x + 12,
          top: hoverClientPos.y + 12,
          background: 'rgba(0,0,0,0.85)',
          color: '#fff',
          padding: '6px 8px',
          borderRadius: '8px',
          fontSize: '12px',
          zIndex: 10000,
          pointerEvents: 'none',
          maxWidth: '260px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
      >
        {hoveredNode.label}
      </div>
    )}
  </div>
</div>

      <GerenciadorDeRotas 
          nodes={nodes}
          edges={edges}
          onDeleteNode={handleDeleteNodeFromList}
          onDeleteEdge={handleDeleteEdgeFromList}
      />

      <Modal isOpen={modalPontoVisivel} toggle={() => setModalPontoVisivel(false)} centered returnFocusAfterClose={false}>
        <ModalHeader toggle={() => setModalPontoVisivel(false)}>Adicionar Ponto de Rota</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="ponto-descricao">Descrição (Opcional)</Label>
            <Input 
              id="ponto-descricao"
              name="descricao"
              placeholder="Ex: Esquina do Corredor A, Em frente ao banheiro"
              value={descricaoNovoPonto}
              onChange={(e) => setDescricaoNovoPonto(e.target.value)}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={(e) => handleSalvarNovoPonto(e)}>Salvar Ponto</Button>{' '}
          <Button color="secondary" onClick={() => setModalPontoVisivel(false)}>Cancelar</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalDestinoVisivel} toggle={() => setModalDestinoVisivel(false)} centered returnFocusAfterClose={false}>
        <ModalHeader toggle={() => setModalDestinoVisivel(false)}>Adicionar Novo Destino</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="destino-nome">Nome do Destino</Label>
            <Input 
              id="destino-nome"
              placeholder="Ex: Ponto de Informações"
              value={nomeNovoDestino}
              onChange={(e) => setNomeNovoDestino(e.target.value)}
            />
          </FormGroup>

          {/* NOVO CAMPO: Tipo de Espaço */}
          <FormGroup>
            <Label for="tipo-espaco">Tipo do Espaço</Label>
            <Input 
              type="select" 
              id="tipo-espaco" 
              value={tipoEspacoSelecionado}
              onChange={(e) => setTipoEspacoSelecionado(e.target.value)}
            >
              <option value="">Selecione um tipo...</option>
              {tiposEspacoFeira.map(item => (
                <option key={item.id} value={item.tipo_espaco_id}>
                  {item.tipo_espaco.nome}
                </option>
              ))}
            </Input>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSalvarNovoDestino}>Salvar Destino</Button>{' '}
          <Button color="secondary" onClick={() => setModalDestinoVisivel(false)}>Cancelar</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalAutoLinkVisivel} toggle={() => { setModalAutoLinkVisivel(false); setAutoLinkPreviewEdges([]); }} centered size="lg" returnFocusAfterClose={false}>
        <ModalHeader toggle={() => { setModalAutoLinkVisivel(false); setAutoLinkPreviewEdges([]); }}>
          Prévia de ligações automáticas
        </ModalHeader>
        <ModalBody>
          <p style={{ marginBottom: '10px' }}>
            Selecione quais ligações você quer aplicar. A prévia aparece no mapa (linhas destacadas).
          </p>

          <div style={{ maxHeight: '320px', overflow: 'auto', border: '1px solid #eee', borderRadius: '8px', padding: '10px' }}>
            {autoLinkPropostas.map((p) => {
              const sourceNode = nodes.find(n => n.id === p.source);
              const targetNode = nodes.find(n => n.id === p.target);
              const label = `${getNodeLabel(sourceNode)} → ${getNodeLabel(targetNode)}  (${Math.round(p.dist)}px)`;
              return (
                <div key={p.key} className="form-check" style={{ marginBottom: '8px' }}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={autoLinkSelecionadas.has(p.key)}
                    onChange={() => {
                      setAutoLinkSelecionadas(prev => {
                        const next = new Set(prev);
                        if (next.has(p.key)) next.delete(p.key);
                        else next.add(p.key);
                        return next;
                      });
                    }}
                    id={p.key}
                  />
                  <label className="form-check-label" htmlFor={p.key} title={label}>
                    {label}
                  </label>
                </div>
              );
            })}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => {
            setAutoLinkSelecionadas(new Set(autoLinkPropostas.map(p => p.key)));
          }}>
            Selecionar tudo
          </Button>
          <Button color="secondary" outline onClick={() => setAutoLinkSelecionadas(new Set())}>
            Limpar
          </Button>
          <Button color="primary" onClick={aplicarAutoLink}>
            Aplicar ligações
          </Button>
          <Button color="secondary" onClick={() => { setModalAutoLinkVisivel(false); setAutoLinkPreviewEdges([]); }}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
  isOpen={modalRegrasFluxoVisivel}
  toggle={fecharModalRegrasFluxo}
  centered
  size="xl"
  returnFocusAfterClose={false}
>
  <ModalHeader toggle={fecharModalRegrasFluxo}>
    Gerenciar Regras de Fluxo
  </ModalHeader>

  <ModalBody>
    <div style={{ maxHeight: 420, overflow: 'auto' }}>
      <table className="table table-sm align-middle">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Prioridade</th>
            <th>Status</th>
            <th>Origens</th>
            <th>Waypoints</th>
            <th style={{ width: 220 }}>Ações</th>
          </tr>
        </thead>
        <tbody>
          {regrasFluxo.length === 0 ? (
            <tr>
              <td colSpan="6" className="text-center text-muted py-4">
                Nenhuma regra cadastrada.
              </td>
            </tr>
          ) : (
            regrasFluxo.map((regra) => (
              <tr key={regra.id}>
                <td>
                  <strong>{regra.nome}</strong>
                  {regra.descricao ? (
                    <div className="text-muted" style={{ fontSize: 12 }}>
                      {regra.descricao}
                    </div>
                  ) : null}
                </td>
                <td>{regra.prioridade}</td>
                <td>
                  <span className={`badge ${regra.ativo ? 'bg-success' : 'bg-secondary'}`}>
                    {regra.ativo ? 'Ativa' : 'Inativa'}
                  </span>
                </td>
                <td>{Array.isArray(regra.origem_nodes) ? regra.origem_nodes.length : 0}</td>
                <td>
                  {Array.isArray(regra.waypoint_nodes)
                    ? regra.waypoint_nodes.length
                    : 0}
                </td>
                <td>
                  <div className="d-flex gap-1 flex-wrap">
                    <Button size="sm" color="primary" outline onClick={() => editarRegraFluxo(regra)}>
                      Editar no mapa
                    </Button>
                    <Button size="sm" color="warning" outline onClick={() => alterarStatusRegraFluxo(regra)}>
                      {regra.ativo ? 'Desativar' : 'Ativar'}
                    </Button>
                    <Button size="sm" color="danger" outline onClick={() => excluirRegraFluxo(regra.id)}>
                      Excluir
                    </Button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  </ModalBody>

  <ModalFooter>
    <Button color="secondary" onClick={fecharModalRegrasFluxo}>
      Fechar
    </Button>
  </ModalFooter>
</Modal>

<Modal
  isOpen={modalSalvarRegraFluxoVisivel}
  toggle={fecharModalSalvarRegraFluxo}
  centered
  size="lg"
  returnFocusAfterClose={false}
>
  <ModalHeader toggle={fecharModalSalvarRegraFluxo}>
    {regraFluxoForm.id ? 'Salvar edição da regra' : 'Salvar nova regra de fluxo'}
  </ModalHeader>

  <ModalBody>
    <div className="row g-3">
      <div className="col-md-6">
        <FormGroup>
          <Label>Nome da regra</Label>
          <Input
            value={regraFluxoForm.nome}
            onChange={(e) =>
              setRegraFluxoForm((prev) => ({ ...prev, nome: e.target.value }))
            }
            placeholder="Ex.: Fluxo externo via Entrada A"
          />
        </FormGroup>
      </div>

      <div className="col-md-3">
        <FormGroup>
          <Label>Prioridade</Label>
          <Input
            type="number"
            min="1"
            value={regraFluxoForm.prioridade}
            onChange={(e) =>
              setRegraFluxoForm((prev) => ({
                ...prev,
                prioridade: e.target.value,
              }))
            }
          />
        </FormGroup>
      </div>

      <div className="col-md-3 d-flex align-items-end">
        <FormGroup check switch>
          <Input
            type="switch"
            checked={!!regraFluxoForm.ativo}
            onChange={(e) =>
              setRegraFluxoForm((prev) => ({
                ...prev,
                ativo: e.target.checked,
              }))
            }
          />
          <Label check>Regra ativa</Label>
        </FormGroup>
      </div>

      <div className="col-12">
        <FormGroup>
          <Label>Descrição</Label>
          <Input
            type="textarea"
            rows="3"
            value={regraFluxoForm.descricao}
            onChange={(e) =>
              setRegraFluxoForm((prev) => ({ ...prev, descricao: e.target.value }))
            }
            placeholder="Ex.: Todo visitante vindo destes acessos deve passar pela Entrada A."
          />
        </FormGroup>
      </div>
    </div>

    <hr />

    <div className="row g-3">
      <div className="col-md-6">
        <Label style={{ fontWeight: 700 }}>Origens selecionadas</Label>
        <div style={{ maxHeight: 180, overflowY: 'auto', border: '1px solid #eee', borderRadius: 8, padding: 10 }}>
          {regraFluxoForm.origem_nodes.length === 0 ? (
            <div className="text-muted">Nenhuma origem selecionada.</div>
          ) : (
            regraFluxoForm.origem_nodes.map((id) => {
              const node = nodes.find((n) => n.id === id);
              const label = node?.description || node?.name || id;
              return (
                <div key={id} className="mb-1">
                  <span className="badge bg-primary">{label}</span>
                </div>
              );
            })
          )}
        </div>
      </div>

      <div className="col-md-6">
        <Label style={{ fontWeight: 700 }}>Passagem obrigatória</Label>
        <div style={{ maxHeight: 180, overflowY: 'auto', border: '1px solid #eee', borderRadius: 8, padding: 10 }}>
          {regraFluxoForm.waypoint_nodes.length === 0 ? (
            <div className="text-muted">Nenhum waypoint selecionado.</div>
          ) : (
            regraFluxoForm.waypoint_nodes.map((id, index) => {
              const node = nodes.find((n) => n.id === id);
              const label = node?.description || node?.name || id;
              return (
                <div key={id} className="mb-1">
                  <span className="badge bg-success">
                    {index + 1}. {label}
                  </span>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  </ModalBody>

  <ModalFooter>
    <Button color="primary" onClick={salvarRegraFluxo} disabled={isSavingRegraFluxo}>
      {isSavingRegraFluxo ? 'Salvando...' : 'Salvar regra'}
    </Button>
    <Button color="secondary" onClick={fecharModalSalvarRegraFluxo}>
      Fechar
    </Button>
  </ModalFooter>
</Modal>
    </div>
  );
};

export default CadastroRoteamentoMapa;